var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":"5000"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},_vm._l((_vm.content),function(message,index){return _c('div',{key:index,staticClass:"subtitle-2"},[_vm._v(" "+_vm._s(message)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }